// Generated by purs version 0.15.0
import * as Data_Day from "../Data.Day/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Set_Serialized from "../Data.Set.Serialized/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Generic from "../Foreign.Generic/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Foreign_Generic_EnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
import * as Restaumatic_Calendar_Types_Availability from "../Restaumatic.Calendar.Types.Availability/index.js";
import * as Restaumatic_I18n_Types from "../Restaumatic.I18n.Types/index.js";
import * as Restaumatic_Menu_V2_Types_MenuConsumer from "../Restaumatic.Menu.V2.Types.MenuConsumer/index.js";
import * as Restaumatic_Promotions_Types_Id from "../Restaumatic.Promotions.Types.Id/index.js";
import * as Restaumatic_PromotionsEngine_Promotions_Promotion from "../Restaumatic.PromotionsEngine.Promotions.Promotion/index.js";
import * as Restaumatic_Restaurant_Types_Id from "../Restaumatic.Restaurant.Types.Id/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Enum from "../Unscramble.Enum/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var Standard = /* #__PURE__ */ (function () {
    function Standard() {

    };
    Standard.value = new Standard();
    return Standard;
})();
var InformationOnly = /* #__PURE__ */ (function () {
    function InformationOnly() {

    };
    InformationOnly.value = new InformationOnly();
    return InformationOnly;
})();
var RequiresCoupon = /* #__PURE__ */ (function () {
    function RequiresCoupon() {

    };
    RequiresCoupon.value = new RequiresCoupon();
    return RequiresCoupon;
})();
var ProductReference = function (x) {
    return x;
};
var Everywhere = /* #__PURE__ */ (function () {
    function Everywhere() {

    };
    Everywhere.value = new Everywhere();
    return Everywhere;
})();
var DeliveryOnly = /* #__PURE__ */ (function () {
    function DeliveryOnly() {

    };
    DeliveryOnly.value = new DeliveryOnly();
    return DeliveryOnly;
})();
var RestaurantOnly = /* #__PURE__ */ (function () {
    function RestaurantOnly() {

    };
    RestaurantOnly.value = new RestaurantOnly();
    return RestaurantOnly;
})();
var TakeawayOnly = /* #__PURE__ */ (function () {
    function TakeawayOnly() {

    };
    TakeawayOnly.value = new TakeawayOnly();
    return TakeawayOnly;
})();
var DeliveryAndTakeaway = /* #__PURE__ */ (function () {
    function DeliveryAndTakeaway() {

    };
    DeliveryAndTakeaway.value = new DeliveryAndTakeaway();
    return DeliveryAndTakeaway;
})();
var Promotion = function (x) {
    return x;
};
var eqPromotionType = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Standard && y instanceof Standard) {
                return true;
            };
            if (x instanceof InformationOnly && y instanceof InformationOnly) {
                return true;
            };
            if (x instanceof RequiresCoupon && y instanceof RequiresCoupon) {
                return true;
            };
            return false;
        };
    }
};
var eqProductReference = {
    eq: function (x) {
        return function (y) {
            return x.productGroupIndex === y.productGroupIndex && x.productSequenceNum === y.productSequenceNum;
        };
    }
};
var eqAvailableAt = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Everywhere && y instanceof Everywhere) {
                return true;
            };
            if (x instanceof DeliveryOnly && y instanceof DeliveryOnly) {
                return true;
            };
            if (x instanceof RestaurantOnly && y instanceof RestaurantOnly) {
                return true;
            };
            if (x instanceof TakeawayOnly && y instanceof TakeawayOnly) {
                return true;
            };
            if (x instanceof DeliveryAndTakeaway && y instanceof DeliveryAndTakeaway) {
                return true;
            };
            return false;
        };
    }
};
var eqPromotion = {
    eq: function (x) {
        return function (y) {
            return x.allowRosCouponsGeneration === y.allowRosCouponsGeneration && x.archived === y.archived && Data_Eq.eq(Restaumatic_Calendar_Types_Availability.eqWeeklyAvailability)(x.availability)(y.availability) && Data_Eq.eq(eqAvailableAt)(x.availableAt)(y.availableAt) && Data_Eq.eq(Restaumatic_PromotionsEngine_Promotions_Promotion.eqPromotionFilter)(x.combineTo)(y.combineTo) && Data_Eq.eq(Restaumatic_PromotionsEngine_Promotions_Promotion.eqPromotionConditions)(x.conditions)(y.conditions) && Data_Eq.eq(Restaumatic_I18n_Types.eqTranslated(Data_Eq.eqString))(x.description)(y.description) && x.enableAutoselect === y.enableAutoselect && Data_Eq.eq(Data_Set_Serialized.eqSet(Restaumatic_Menu_V2_Types_MenuConsumer.eqMenuConsumer))(x.enabledMenuConsumers)(y.enabledMenuConsumers) && Data_Eq.eq(Data_Day.eqDay)(x.finish)(y.finish) && Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqString))(x.groupId)(y.groupId) && Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqString))(x.imageUrl)(y.imageUrl) && Data_Eq.eq(Restaumatic_I18n_Types.eqTranslated(Data_Eq.eqString))(x.name)(y.name) && Data_Eq.eq(Restaumatic_PromotionsEngine_Promotions_Promotion.eqPromotionPrize)(x.prize)(y.prize) && Data_Eq.eq(Restaumatic_Promotions_Types_Id.eqPromotionId)(x.promotionId)(y.promotionId) && Data_Eq.eq(eqPromotionType)(x.promotionType)(y.promotionType) && x.requiresMarketing === y.requiresMarketing && Data_Eq.eq(Restaumatic_Restaurant_Types_Id.eqRestaurantId)(x.restaurantId)(y.restaurantId) && Data_Eq.eq(Data_Day.eqDay)(x.start)(y.start) && x.visible === y.visible;
        };
    }
};
var newtypePromotion = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeProductReference = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldPromotion = function (dictHasField) {
    return dictHasField;
};
var hasFieldProductReference = function (dictHasField) {
    return dictHasField;
};
var genericPromotionType = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return Standard.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return InformationOnly.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
            return RequiresCoupon.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Promotions.Types (line 37, column 1 - line 37, column 81): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Standard) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof InformationOnly) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof RequiresCoupon) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value));
        };
        throw new Error("Failed pattern match at Restaumatic.Promotions.Types (line 37, column 1 - line 37, column 81): " + [ x.constructor.name ]);
    }
};
var showPromotionType = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericPromotionType)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Standard";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "InformationOnly";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "RequiresCoupon";
        }
    }))))
};
var unscrambleDecodePromotionType = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Enum.genericUnsafeDecodeEnum(genericPromotionType)(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "Standard";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "InformationOnly";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "RequiresCoupon";
        }
    }))))(Unscramble_Enum.defaultEnumOptions)
};
var genericPromotion = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var genericProductReference = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showProductReference = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericProductReference)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "productGroupIndex";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "productSequenceNum";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Show.showInt))(Data_Show.showInt))))({
        reflectSymbol: function () {
            return "ProductReference";
        }
    }))
};
var unscrambleDecodeProductReference = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericProductReference)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "productGroupIndex";
        }
    })(Unscramble.decodeInt1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "productSequenceNum";
        }
    })(Unscramble.decodeInt1)(Unscramble.decodeRecordNil))))))(Unscramble_Generic.defaultOptions)
};
var genericAvailableAt = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return Everywhere.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return DeliveryOnly.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return RestaurantOnly.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return TakeawayOnly.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inr))) {
            return DeliveryAndTakeaway.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Promotions.Types (line 24, column 1 - line 24, column 77): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Everywhere) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof DeliveryOnly) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof RestaurantOnly) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
        };
        if (x instanceof TakeawayOnly) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))));
        };
        if (x instanceof DeliveryAndTakeaway) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value))));
        };
        throw new Error("Failed pattern match at Restaumatic.Promotions.Types (line 24, column 1 - line 24, column 77): " + [ x.constructor.name ]);
    }
};
var showAvailableAt = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericAvailableAt)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Everywhere";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "DeliveryOnly";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "RestaurantOnly";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "TakeawayOnly";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "DeliveryAndTakeaway";
        }
    }))))))
};
var showPromotion = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericPromotion)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "allowRosCouponsGeneration";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "archived";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "availability";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "availableAt";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "combineTo";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "conditions";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "description";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "enableAutoselect";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "enabledMenuConsumers";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "finish";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "groupId";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "imageUrl";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "prize";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "promotionId";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "promotionType";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "requiresMarketing";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "restaurantId";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "start";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "visible";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Show.showBoolean))(Data_Day.showDay))(Restaumatic_Restaurant_Types_Id.showRestaurantId))(Data_Show.showBoolean))(showPromotionType))(Restaumatic_Promotions_Types_Id.showPromotionId))(Restaumatic_PromotionsEngine_Promotions_Promotion.showPromotionPrize))(/* #__PURE__ */ Restaumatic_I18n_Types.showTranslated(Data_Show.showString)))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString)))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString)))(Data_Day.showDay))(/* #__PURE__ */ Data_Set_Serialized.showSet(Restaumatic_Menu_V2_Types_MenuConsumer.showMenuConsumer)))(Data_Show.showBoolean))(/* #__PURE__ */ Restaumatic_I18n_Types.showTranslated(Data_Show.showString)))(Restaumatic_PromotionsEngine_Promotions_Promotion.showPromotionConditions))(Restaumatic_PromotionsEngine_Promotions_Promotion.showPromotionFilter))(showAvailableAt))(Restaumatic_Calendar_Types_Availability.showWeeklyAvailability))(Data_Show.showBoolean))(Data_Show.showBoolean))))({
        reflectSymbol: function () {
            return "Promotion";
        }
    }))
};
var unscrambleDecodeAvailableAt = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Enum.genericUnsafeDecodeEnum(genericAvailableAt)(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "Everywhere";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "DeliveryOnly";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "RestaurantOnly";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "TakeawayOnly";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "DeliveryAndTakeaway";
        }
    }))))))(Unscramble_Enum.defaultEnumOptions)
};
var unscrambleDecodePromotion = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericPromotion)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "allowRosCouponsGeneration";
        }
    })(Unscramble.decodeBoolean1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "archived";
        }
    })(Unscramble.decodeBoolean1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "availability";
        }
    })(Restaumatic_Calendar_Types_Availability.decodeWeeklyAvailability)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "availableAt";
        }
    })(unscrambleDecodeAvailableAt)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "combineTo";
        }
    })(Restaumatic_PromotionsEngine_Promotions_Promotion.udecodePromotionFilter)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "conditions";
        }
    })(Restaumatic_PromotionsEngine_Promotions_Promotion.udecodePromotionConditions)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "description";
        }
    })(/* #__PURE__ */ Restaumatic_I18n_Types.udecodeTranslated(Unscramble.decodeString1))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "enableAutoselect";
        }
    })(Unscramble.decodeBoolean1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "enabledMenuConsumers";
        }
    })(/* #__PURE__ */ Data_Set_Serialized.udecodeSet(Restaumatic_Menu_V2_Types_MenuConsumer.ordMenuConsumer)(Restaumatic_Menu_V2_Types_MenuConsumer.unscrambleDecodeMenuConsumer))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "finish";
        }
    })(Data_Day.udecodeDay)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "groupId";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeString1))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "imageUrl";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeString1))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Restaumatic_I18n_Types.udecodeTranslated(Unscramble.decodeString1))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "prize";
        }
    })(Restaumatic_PromotionsEngine_Promotions_Promotion.udecodePromotionPrize)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "promotionId";
        }
    })(Restaumatic_Promotions_Types_Id.decodePromotionId)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "promotionType";
        }
    })(unscrambleDecodePromotionType)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "requiresMarketing";
        }
    })(Unscramble.decodeBoolean1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "restaurantId";
        }
    })(Restaumatic_Restaurant_Types_Id.udecodeRestaurantId)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "start";
        }
    })(Data_Day.udecodeDay)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "visible";
        }
    })(Unscramble.decodeBoolean1)(Unscramble.decodeRecordNil))))))))))))))))))))))))(Unscramble_Generic.defaultOptions)
};
var encodingOpts = /* #__PURE__ */ (function () {
    return {
        sumEncoding: Foreign_Generic_Class.defaultOptions.sumEncoding,
        unwrapSingleConstructors: true,
        unwrapSingleArguments: Foreign_Generic_Class.defaultOptions.unwrapSingleArguments,
        unwrapSingleRecordArguments: true,
        fieldTransform: Foreign_Generic_Class.defaultOptions.fieldTransform
    };
})();
var encodePromotionType = {
    encode: /* #__PURE__ */ Foreign_Generic_EnumEncoding.genericEncodeEnum(genericPromotionType)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "Standard";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "InformationOnly";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "RequiresCoupon";
        }
    }))))(Foreign_Generic_EnumEncoding.defaultGenericEnumOptions)
};
var encodeProductReference = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericProductReference)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "ProductReference";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "productSequenceNum";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode)))({
        reflectSymbol: function () {
            return "productGroupIndex";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode))))))(encodingOpts)
};
var encodeAvailableAt = {
    encode: /* #__PURE__ */ Foreign_Generic_EnumEncoding.genericEncodeEnum(genericAvailableAt)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "Everywhere";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "DeliveryOnly";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "RestaurantOnly";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "TakeawayOnly";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "DeliveryAndTakeaway";
        }
    }))))))(Foreign_Generic_EnumEncoding.defaultGenericEnumOptions)
};
var encodePromotion = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericPromotion)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Promotion";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "visible";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.booleanEncode)))({
        reflectSymbol: function () {
            return "start";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Day.encodeDay)))({
        reflectSymbol: function () {
            return "restaurantId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Restaurant_Types_Id.encodeRestaurantId)))({
        reflectSymbol: function () {
            return "requiresMarketing";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.booleanEncode)))({
        reflectSymbol: function () {
            return "promotionType";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodePromotionType)))({
        reflectSymbol: function () {
            return "promotionId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Promotions_Types_Id.encodePromotionId)))({
        reflectSymbol: function () {
            return "prize";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_PromotionsEngine_Promotions_Promotion.encodePromotionPrize)))({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Restaumatic_I18n_Types.encodeTranslated(Foreign_Generic_Class.stringEncode))))({
        reflectSymbol: function () {
            return "imageUrl";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode))))({
        reflectSymbol: function () {
            return "groupId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode))))({
        reflectSymbol: function () {
            return "finish";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Day.encodeDay)))({
        reflectSymbol: function () {
            return "enabledMenuConsumers";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Data_Set_Serialized.encodeSet(Restaumatic_Menu_V2_Types_MenuConsumer.encodeMenuConsumer))))({
        reflectSymbol: function () {
            return "enableAutoselect";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.booleanEncode)))({
        reflectSymbol: function () {
            return "description";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Restaumatic_I18n_Types.encodeTranslated(Foreign_Generic_Class.stringEncode))))({
        reflectSymbol: function () {
            return "conditions";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_PromotionsEngine_Promotions_Promotion.encodePromotionConditions)))({
        reflectSymbol: function () {
            return "combineTo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_PromotionsEngine_Promotions_Promotion.encodePromotionFilter)))({
        reflectSymbol: function () {
            return "availableAt";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeAvailableAt)))({
        reflectSymbol: function () {
            return "availability";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Calendar_Types_Availability.encodeWeeklyAvailability)))({
        reflectSymbol: function () {
            return "archived";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.booleanEncode)))({
        reflectSymbol: function () {
            return "allowRosCouponsGeneration";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.booleanEncode))))))(encodingOpts)
};
var decodePromotionType = {
    decode: /* #__PURE__ */ Foreign_Generic_EnumEncoding.genericDecodeEnum(genericPromotionType)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "Standard";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "InformationOnly";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "RequiresCoupon";
        }
    }))))(Foreign_Generic_EnumEncoding.defaultGenericEnumOptions)
};
var decodeProductReference = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericProductReference)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "ProductReference";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "productSequenceNum";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode))())({
        reflectSymbol: function () {
            return "productGroupIndex";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))(encodingOpts)
};
var decodeAvailableAt = {
    decode: /* #__PURE__ */ Foreign_Generic_EnumEncoding.genericDecodeEnum(genericAvailableAt)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "Everywhere";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "DeliveryOnly";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "RestaurantOnly";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "TakeawayOnly";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "DeliveryAndTakeaway";
        }
    }))))))(Foreign_Generic_EnumEncoding.defaultGenericEnumOptions)
};
var decodePromotion = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericPromotion)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "Promotion";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "visible";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.booleanDecode))())({
        reflectSymbol: function () {
            return "start";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_Day.decodeDay))())({
        reflectSymbol: function () {
            return "restaurantId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Restaurant_Types_Id.decodeRestaurantId))())({
        reflectSymbol: function () {
            return "requiresMarketing";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.booleanDecode))())({
        reflectSymbol: function () {
            return "promotionType";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodePromotionType))())({
        reflectSymbol: function () {
            return "promotionId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Promotions_Types_Id.decodePromotionId1))())({
        reflectSymbol: function () {
            return "prize";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_PromotionsEngine_Promotions_Promotion.decodePromotionPrize))())({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Restaumatic_I18n_Types.decodeTranslated(Foreign_Generic_Class.stringDecode)))())({
        reflectSymbol: function () {
            return "imageUrl";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.stringDecode)))())({
        reflectSymbol: function () {
            return "groupId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.stringDecode)))())({
        reflectSymbol: function () {
            return "finish";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_Day.decodeDay))())({
        reflectSymbol: function () {
            return "enabledMenuConsumers";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Data_Set_Serialized.decodeSet(Restaumatic_Menu_V2_Types_MenuConsumer.ordMenuConsumer)(Restaumatic_Menu_V2_Types_MenuConsumer.decodeMenuConsumer)))())({
        reflectSymbol: function () {
            return "enableAutoselect";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.booleanDecode))())({
        reflectSymbol: function () {
            return "description";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Restaumatic_I18n_Types.decodeTranslated(Foreign_Generic_Class.stringDecode)))())({
        reflectSymbol: function () {
            return "conditions";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_PromotionsEngine_Promotions_Promotion.decodePromotionConditions))())({
        reflectSymbol: function () {
            return "combineTo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_PromotionsEngine_Promotions_Promotion.decodePromotionFilter))())({
        reflectSymbol: function () {
            return "availableAt";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeAvailableAt))())({
        reflectSymbol: function () {
            return "availability";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Calendar_Types_Availability.decodeWeeklyAvailability1))())({
        reflectSymbol: function () {
            return "archived";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.booleanDecode))())({
        reflectSymbol: function () {
            return "allowRosCouponsGeneration";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.booleanDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))(encodingOpts)
};
export {
    Everywhere,
    DeliveryOnly,
    RestaurantOnly,
    TakeawayOnly,
    DeliveryAndTakeaway,
    Standard,
    InformationOnly,
    RequiresCoupon,
    ProductReference,
    Promotion,
    encodingOpts,
    genericAvailableAt,
    showAvailableAt,
    eqAvailableAt,
    decodeAvailableAt,
    unscrambleDecodeAvailableAt,
    encodeAvailableAt,
    genericPromotionType,
    showPromotionType,
    eqPromotionType,
    decodePromotionType,
    unscrambleDecodePromotionType,
    encodePromotionType,
    genericProductReference,
    showProductReference,
    eqProductReference,
    decodeProductReference,
    unscrambleDecodeProductReference,
    encodeProductReference,
    newtypeProductReference,
    hasFieldProductReference,
    genericPromotion,
    showPromotion,
    eqPromotion,
    decodePromotion,
    unscrambleDecodePromotion,
    encodePromotion,
    newtypePromotion,
    hasFieldPromotion
};
//# sourceMappingURL=index.js.map
